import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8 23h8v-2H8v2zM18 1.01L6 1v18h12V1.01zM16 15H8V5h8v10z"
}), 'DockSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DockSharp.js
// module id = 3221
// module chunks = 2